import ActionType from '../action-types';

const initialState = {
  header: '',
  subHeader: '',
  backLink: ''
};

// eslint-disable-next-line default-param-last
const appInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.SET_HEADER:
      return {
        ...state,
        header: action.payload
      };
    case ActionType.SET_SUB_HEADER:
      return {
        ...state,
        subHeader: action.payload
      };
    case ActionType.SET_BACK_LINK:
      return {
        ...state,
        backLink: action.payload
      };

    default:
      return state;
  }
};

export default appInfoReducer;
